<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/167pww6/tc-custom/9781453200438.jpg?1733088072671" alt="This image is the cover for the book Savage Day, The Simon Vaughan Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Savage Day, The Simon Vaughan Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>A desperate man goes up against the IRA to buy his freedom in this heart-racing thriller from the <i>New York Times</i>–bestselling author of <i>The Midnight Bell</i>.</b><br/>  <br/> After surviving the war in Korea, Simon Vaughan decided the only loyalty he had was to the man in the mirror. For a while, the high-risk job of arms dealing seemed to be just the life for him. Too bad the Greek authorities didn’t see it that way when they tossed him in prison.<br/>  <br/> But now he’s gotten a reprieve from an unlikely source: the British Army. And if he wants out, he’s going to have to play their game.<br/>  <br/> It seems that the Irish Republican Army has made off with a half-million dollars in gold bullion. The Brits want it back. And their best bet is to send someone tough, resourceful, and completely expendable—which is Vaughan to the letter.<br/>  <br/> Venturing into the bloody underground of a violent rebellion, Vaughan must navigate a deadly maze of friends, foes, and those in between, if he’s going to get the gold, get the bad guys, and get out in one piece . . .<br/>  <br/> The author of the Sean Dillon and Liam Devlin series, including the classic <i>The Eagle Has Landed</i>, Jack Higgins has enthralled millions of readers around the world with his explosive novels of spies and espionage, heroes and villains, and fast-paced storytelling that have made him a true mastermind of the modern thriller.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Higgins
      </h2>
      
      <p class="authorDescription body article"><P> Jack Higgins is the <I>New York Times</I> bestselling author of more than sixty thrillers that have sold over 250 million copies worldwide, including <I>The Eagle Has Landed</I> and <I>The Wolf at the Door</I>. Before beginning his writing career, Higgins served in the British Army along the East German border. He lives in the Channel Islands. </P><P> &#160; </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?94ddd702